






























import Vue from 'vue';
import { Component, Emit, Prop } from 'vue-property-decorator';
import { Mutation, State } from 'vuex-class';
import TabItem from '@kasasa/portal-components/src/components/types/tabitem';
import { PortalAppHeader } from '@kasasa/portal-components';
import router from '@/router';
import tabs from '@/tabs';

@Component({
  components: {
    PortalAppHeader,
  },
})


export default class App extends Vue {
  appTitle: string = 'Platform Integrations - Config';

  tabItems: TabItem[] = tabs;

  errorMessage:string = '';

  authStatus:boolean = false;

  @Emit('error')
  showErrorMessage(error: string) {
    this.errorMessage = error;
  }


  @State('user') stateUser: any;

  @Mutation('user') mutationUser: any;

  @State('portalHeaderData') statePortalHeaderData: any;

  @Mutation('portalHeaderData') mutationPortalHeaderData: any;

  @Emit('user')
  setUser(user: any) {
    this.mutationUser(user);
  }

  @Emit('headerData')
  setHeaderData(data: any) {
    this.mutationPortalHeaderData(data);
  }

  async beforeMount() {
    this.$http
      .get('/api/user/') // AuthInterceptor will handle redirect for a 401
      .then((response:any) => {
        this.authStatus = true;
      })
      .catch((error:any) => {
        if (error.response.status === 401) {
          const redirect = encodeURIComponent(window.location.href);
          window.location.href = `/api/auth/login?callback=${redirect}`;
        } else {
          this.authStatus = true;
        }
      });
  }
}

